import { useState } from "react";
import { useLang } from "@/i18n";
import { extra } from "@/content-extra";

const KEY = "vps_cookie_consent";

export default function CookieBanner() {
  const { lang } = useLang();
  const [visible, setVisible] = useState(() => !localStorage.getItem(KEY));
  if (!visible) return null;
  const c = extra[lang].cookie;

  const choose = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  return (
    <div className="fixed bottom-5 left-5 right-5 sm:right-auto sm:max-w-md z-50 glass rounded-2xl p-5 !bg-carbon/90" data-testid="cookie-banner">
      <p className="text-sm text-steel leading-relaxed">{c.text}</p>
      <div className="mt-4 flex gap-3">
        <button onClick={() => choose("accepted")} className="btn-primary !py-2 !px-5 !text-xs" data-testid="cookie-accept-button">{c.accept}</button>
        <button onClick={() => choose("rejected")} className="btn-outline !py-2 !px-5 !text-xs" data-testid="cookie-reject-button">{c.reject}</button>
      </div>
    </div>
  );
}
